export const query_get_all_user_tenant = `
query getAllUserTenant($tenantId: String!) {
    user_tenant(where: {TenantId: {_eq: $tenantId}, Type : {_neq: "OWNER"}}) {
        UserId
        TenantId
        Type
        TenantTipoId    
    }
}`;   